import {getSissiEncoreUrl} from "../../config/server";

const BASE = () => `${getSissiEncoreUrl()}/countries`;

async function parseError(response) {
  try {
    const body = await response.json();
    return body.message || response.statusText;
  } catch (_e) {
    return response.statusText;
  }
}

async function getCountries(params = {}) {
  const query = {
    ...params,
    q: params.name || params.filter,
    skip: params.skip || 0,
    limit: params.limit || 50,
  };
  if (!query.q) delete query.q;
  delete query.filter;
  delete query.name;

  const url = new URL(BASE());
  url.search = new URLSearchParams(query).toString();

  const res = await fetch(decodeURIComponent(url.toString()), {
    credentials: 'include',
    mode: 'cors',
  });
  if (res.status !== 200) {
    throw new Error(await parseError(res));
  }
  return res.json();
}

async function getCountry(id) {
  const res = await fetch(`${BASE()}/${id}`, {credentials: 'include', mode: 'cors'});
  if (res.status === 404) {
    return null;
  }
  if (res.status !== 200) {
    throw new Error(await parseError(res));
  }
  return res.json();
}

async function saveCountry(country) {
  const res = await fetch(BASE(), {
    method: 'POST',
    credentials: 'include',
    mode: 'cors',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify(country),
  });
  if (!res.ok) {
    throw new Error(await parseError(res));
  }
  return res.json();
}

async function updateCountry(id, country) {
  const res = await fetch(`${BASE()}/${id}`, {
    method: 'PUT',
    credentials: 'include',
    mode: 'cors',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify(country),
  });
  if (!res.ok) {
    throw new Error(await parseError(res));
  }
  return res.json();
}

async function deleteCountry(country) {
  const id = typeof country === 'object' ? country.id : country;
  const res = await fetch(`${BASE()}/${id}`, {
    method: 'DELETE',
    credentials: 'include',
    mode: 'cors',
  });
  if (!res.ok) {
    throw new Error(await parseError(res));
  }
  const body = await res.json();
  return !!body.success;
}

export {getCountries, getCountry, saveCountry, updateCountry, deleteCountry};
